module.exports = __webpack_public_path__ + "static/media/WRDP.ee71e228.jpg";